module.exports = __webpack_public_path__ + "static/reading-image-10b1fc65c614877b072a64a13f1bfab5.png";